

// import react
import React, { useState, useEffect } from "react";


// import images 

import logo from './images/logo.png';
import gruscheweg from "./images/swiper/gruscheweg1.png";
import neuburgerring from "./images/swiper/neuburgerring.png"
import machonstrasse from "./images/swiper/machonstrasse.png";
import ahornring from "./images/swiper/ahornring.png";
import frank_boehme from "./images/homepage/frank_boehme.png";
// import styles
import "./header4.scss";
import "./animation1.scss";


// import Components
import Spanizer from "./Spanizer";
import HomeButton from './homebutton';


const divsToUpdate = document.querySelectorAll(".boilerplate-update-me-header2")

divsToUpdate.forEach(div => {
  const data = JSON.parse(div.querySelector("pre").innerText)
  ReactDOM.render(<Header {...data} />, div)
  div.classList.remove("boilerplate-update-me-header2")
})

const MemoizedHomeButton = React.memo(HomeButton);

function Header({title}) {

    const [menuVisible, setMenuVisible] = useState(false);
    const [buttonOpen, setButtonOpen] = useState(false);

   
    useEffect(() => {

  
      let current = 0;
 
      // Function to update current class for both sets of elements
      const updateCurrent = () => {
        // Selecting both sets of elements
        const imageLayers = document.querySelectorAll('.ui-image');
        const articleLayers = document.querySelectorAll('.ui-layer:not(.ui-image)');

        // Updating for image layers
        imageLayers.forEach(el => el.classList.remove('-current'));
        if (imageLayers[current]) {
          imageLayers[current].classList.add('-current');
        }

        // Updating for article layers
        articleLayers.forEach(el => el.classList.remove('-current'));
        if (articleLayers[current]) {
          articleLayers[current].classList.add('-current');
        }

        // Update the index for the next element
        current = (current + 1) % imageLayers.length;
      };

      // Start the automatic update
      const interval = setInterval(updateCurrent, 6500);

      return () => clearInterval(interval);
    }, []);

  return (
    <>
<div className="hero-main">
<a href="../" className="overlay-image" ><img src={logo} alt="Descriptive Text" /> </a>
<div className={`hero-main__container header4 ${menuVisible ? '-visible' : ''}`}>

  <div className="ui-right">

  <div className="ui-title"> 
  <span style={{ color: "#008ad3" }}>
              Immo<span style={{ color: "#eb7901" }}>gain</span>
              <span style={{ color: "white" }}> GmbH</span>
              <br></br>
              <p className="mast__text home-subtitle">
        <Spanizer
          text="Wir schaffen bleibende Werte"
        />
    </p>
            </span>
  </div>
  <div className="ui-page-title">
  <h1>{title} </h1>
    </div> 








  </div>
  <div className="ui-sidebar">
  <div className="ui-button" role="button" onClick={() => {
          setMenuVisible(!menuVisible);
          setButtonOpen(!buttonOpen);
        }}>
      
    </div>
  </div>
  

  
  <div className={`ui-menu ${menuVisible ? '-visible' : ''}`}>
    
    <div className="ui-left">
      <div className="ui-header"></div>
      <div className="ui-section">
        <div className="ui-heading">Maklertätigkeit</div>
        <ul className="ui-list">
          <li className="ui-item">An- und Verkaufsvermittlung</li>
          <li className="ui-item">Finanzierungsberatung</li>
          <li className="ui-item">Werteermittlung</li>
          <li className="ui-item">Vermietung & Verwaltung</li>
          <li className="ui-item">Umfangreiche Datenbank</li>
        </ul>
      </div>
 
      <div className="ui-section">
        <div className="ui-heading">Leistungen für Privatkunden</div>
        <ul className="ui-list">
          <li className="ui-item">Marktwertermittlung</li>
          <li className="ui-item">Martwertschätzung</li>
          <li className="ui-item">Immobilienkaufberatung</li>
        </ul>
      </div>
      <div className="ui-section">
        <div className="ui-heading">Leistungen für Kreditinstitute</div>
        <ul className="ui-list">
          <li className="ui-item">Markt- und­ Beleihungs­werteermittlung</li>
          <li className="ui-item">vereinfachte Werteermittlung</li>
          <li className="ui-item">Immobilien­besichtigung</li>
        </ul>
      </div>
      <div className="ui-section">
        <div className="ui-heading">Bauträger</div>
        <ul className="ui-list">
          <li className="ui-item">Erschaffung neuer Lebensräume</li>
          <li className="ui-item">Bau und Erhalt der Immobilie</li>
          <li className="ui-item">Verwaltung der Immobilie</li>
        </ul>
      </div>

    </div>
    <div className="ui-right">
      <div className="ui-headings">        
        <h2 className="ui-heading"> <a href="../">Home</a></h2>
        <h2 className="ui-heading"><a href="../#about">Über uns</a></h2>
        <h2 className="ui-heading"><a href="../referenzobjekte"> Referenzobjekte</a></h2>
        <h2 className="ui-heading"><a href="../#kontakt-formular">Kontakt</a></h2>
        <h2 className="ui-heading"><a href="../impressum">Impressum</a></h2>
        <h2 className="ui-heading"><a href="../glossar">Glossar</a></h2>
      </div>
    </div>
  </div>
</div>

</div>

    </>
  );
};


export default Header;


